import { html, css, LitElement, nothing } from 'lit';
import { repeat } from 'lit-html/directives/repeat.js'

import { WinhagerScheduleSwitchPoint } from './windhager-schedule-switchpoint';
import { localize } from './localize/localize';

export class WindhagerScheduleBlock extends LitElement {

    // internal reactive states
    static get properties() {
        return {
						weekdays: { state: false },
						switchPoints: { state: false },
        };
    }

	render() {
		let disableAdd = this.switchPoints.length >= 6;
		let disableRemove = this.switchPoints.length <= 1;

		return html`
			<div class="windhager-block">
				<div class="windhager-weekdays" >
					${this.renderWeekdays()}
				</div>
				${repeat(this.switchPoints, item => item.value + "@" + item.time,
				(item,index) => html`<windhager-schedule-switchpoint time="${item.time}" temperature="${item.value}" .parent="${this}" .index="${index}" disableAdd="${disableAdd}" disableRemove="${disableRemove}" @sp-changed="${this.SPChangedHandler}"/>`)}
			</div>
		`;
	}

	SPChangedHandler(event) {
		const index = event.detail["index"];
		const time = event.detail["time"];
		const temperature = event.detail["value"];

		if (index >= 0 && index < this.switchPoints.length) {
			this.switchPoints[index]["value"] = temperature;
			this.switchPoints[index]["time"] = time;
			this.requestUpdate();
		}
	}

		
	renderWeekdays() {
		const allWeekdays = ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'];
		return allWeekdays.map((day) => this.renderButton(day));
	}

	renderButton(day) {
		let active = this.weekdays.includes(day);
		return html`
				<mwc-button
					class="${active ? 'active' : ''}"
					@click="${() => this.toggleDay(day)}"
				/>
				${localize('weekdays.' + day)}
				</mwc-button>
		`;
	}

	addSwitchPoint() {
		if (this.switchPoints.length >= 6) {
			return;
		}
		let sp = {"time": "00:00", "value": 20};
		if (this.switchPoints.length > 0) {
			this.switchPoints.push(sp);
		} else {
			this.switchPoints = [ sp ];
		}
		this.requestUpdate();
	}

	removeSwitchPoint(index) {
		if (this.switchPoints.length > 1) {
			// remove element at index
			this.switchPoints.splice(index, 1);
		}
		this.requestUpdate();
	}

	toggleDay(day) {
		let active = this.weekdays.includes(day);

		if (active) {
			if (this.weekdays.length <= 1)
				return;
			const i = this.weekdays.indexOf(day);
			this.weekdays.splice(i, 1);
			this.parent.addBlock({"weekdays": [day], "switchPoints": this.switchPoints});
		} else {
			this.parent.removeDay(day);
			this.weekdays.push(day);
		}

		this.requestUpdate();
	}

	// Removes day from weekdays (if contained)
	// returns -1 if day not contained, length of weekdays otherwise
	removeDay(day) {
		const i = this.weekdays.indexOf(day);
		if (i == -1)
			return -1;
		this.weekdays.splice(i, 1);
		return this.weekdays.size;
	}

	static styles = css`
		.windhager-block {
			border-width: 1px;
			border-style: solid;
			border-radius: 4px;
			margin: 12px 0px;
		}
		.windhager-weekdays {
			display: flex;
			flex-wrap: wrap;
			justify-content: flex-start;
		}
		mwc-button {
			margin: 4px;
		}
    mwc-button.active {
		  background: var(--primary-color);
		  --mdc-theme-primary: var(--text-primary-color);
		  border-radius: 4px;
		}
	`;
}
customElements.define('windhager-schedule-block', WindhagerScheduleBlock);
